import { selectUpdateEmployeeStatus, updateEmployee } from "_redux/slices/timeline/employees";
import { saveEmployeeShift } from "_redux/slices/timeline/timeline-data";
import { selectFirebaseUser } from "_redux/slices/main-screen/user";
import { Colors } from "_styles";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';

const AddEmployeeShift = ({ closeModal, employee }) => {
    const dispatch = useDispatch();
    const updateEmpstatus = useSelector(selectUpdateEmployeeStatus);
    const firebaseUser = useSelector(selectFirebaseUser)
    const now = moment();
    const [startDate, setStartDate] = useState(now);
    const [endDate, setEndDate] = useState(moment(now).add(12, 'hours'));
    const [autoStart, setAutoStart] = useState(""); // "now" | "nextHour"
    const [shiftDuration, setShiftDuration] = useState(8); // in hours

    useEffect(() => {
        if (updateEmpstatus === "succeeded") closeModal();
    }, [updateEmpstatus]);

    useEffect(() => {
        let newStart = moment();

        if (autoStart === "nextHour") {
            const nextHour = moment().startOf("hour").add(1, "hour");
            newStart = nextHour;
        }

        setStartDate(newStart);
        setEndDate(moment(newStart).add(shiftDuration, "hours"));
    }, [autoStart, shiftDuration]);

    const saveShift = () => {
        const shift = {
            start: startDate.toISOString(),
            end: endDate.toISOString(),
        };

        const payLoad = {
            userId: employee.userId,
            body: {
                status: "online",
                shift
            }
        };

        const shiftPayload = {
            userId: employee.userId,
            airport: employee.airport,
            employeeId: employee.employeeId,
            shift,
            deviceInfo: {
                brand: "web",
                model: "web"
            },
            createdBy: firebaseUser?.email || firebaseUser?.uid || "unknown"
        };

        dispatch(updateEmployee(payLoad));
        dispatch(saveEmployeeShift(shiftPayload));
    };

    const handleStartChange = (e) => {
        const newStart = moment(e.target.value);
        setStartDate(newStart);

        const newEnd = moment(newStart).add(shiftDuration, 'hours');
        setEndDate(newEnd);
    };

    const handleEndChange = (e) => {
        setEndDate(moment(e.target.value));
    };

    return (
        <Row>
            <Col xs={12}>
                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Start Options</Form.Label>
                <Form.Check
                    type="radio"
                    name="startOption"
                    label="Start Now"
                    checked={autoStart === "now"}
                    onChange={() => setAutoStart("now")}
                />
                <Form.Check
                    type="radio"
                    name="startOption"
                    label="Start Next Hour"
                    checked={autoStart === "nextHour"}
                    onChange={() => setAutoStart("nextHour")}
                />
            </Col>

            <Col xs={12} className="mt-2 mb-3">
                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Start Shift</Form.Label>
                <Form.Control
                    type="datetime-local"
                    value={startDate.format('YYYY-MM-DDTHH:mm')}
                    min={moment().format('YYYY-MM-DDTHH:mm')}
                    onChange={handleStartChange}
                />
            </Col>

            <Col xs={12}>
                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Shift Duration</Form.Label>

                {[8, 10, 12].map((hrs) => (
                    <Form.Check
                        inline
                        key={hrs}
                        type="radio"
                        name="shiftDuration"
                        label={`${hrs} hours`}
                        checked={shiftDuration === hrs}
                        onChange={() => setShiftDuration(hrs)}
                    />
                ))}
            </Col>

            <Col xs={12} className="mt-2 mb-3">
                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>End Shift</Form.Label>
                <Form.Control
                    type="datetime-local"
                    value={endDate.format('YYYY-MM-DDTHH:mm')}
                    min={startDate.format('YYYY-MM-DDTHH:mm')}
                    max={moment(startDate).add(24, 'hours').format('YYYY-MM-DDTHH:mm')}
                    onChange={handleEndChange}
                />
            </Col>

            <Col xs={12} className="d-flex justify-content-end gap-2">
                <Button variant="outline-secondary" onClick={closeModal}>Cancel</Button>
                <Button onClick={saveShift}>Save</Button>
            </Col>
        </Row>
    );
};

export default AddEmployeeShift;
